<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading" >
    <mapfre-card [singleCard]="false" [additionalClasses]="'billing-request fs-18 lh-24'">
        <div class="border-bottom-1-9CB0BC fs-16 pb-3 mb-4 refund-request-header">
            <h1 class="title-copy dm-sans">{{ "WHAT_CAN_WE_HELP" | translate }}</h1>
            <p class="mb-0 col-526570">{{ "RESPONSE_WITHIN_TWO_FOUR" | translate }}</p>
            <p class="mb-0 col-526570">
                {{ "IMMEDIATE_ASSISTANCE" | translate }}
                <a routerLink='/contact' class="see-dec">{{ "CONTACT_US_2" | translate }}</a>.
            </p>
        </div>

        <app-billing-header 
            [policyTypeImg]="policyTypeImg" [policyType]="policyType" 
            [policyNumber]="policy?.policynumber.policyNumber" [policy]="policy"
        >
        </app-billing-header>
        
        <div class="fw-500 padding-top pt8 dm-sans-medium">
            {{ "TELL_ABOUT_REQUEST" | translate }}
        </div>
        <ng-container *ngFor="let request of requestTypeList; index as i">
            <ng-container >
            <mapfre-button additionalClasses="request fs-16 mr-{{ ((i + 1) % 2) * 3 }} dm-sans-medium ma-text-color"
                            (click)="processRequest(request)">
                {{ request }}
            </mapfre-button>
            </ng-container>
        </ng-container>

        <!-- <ng-template #otherRequesr>
            <app-other-request [policy]="policy"></app-other-request>
        </ng-template> -->
    </mapfre-card>
</ng-container>
